import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../../auth/auth-guard.service';
import { LicenceKeysComponent } from './LicenceKeys.component';
import { LicenceKeyComponent } from './licencekey.component';

const routes: Routes = [
  {
    path: '',
    component: LicenceKeysComponent, canActivate: [AuthGuard],
    data: { permissions: ['adminAccess']},
    children: [

      {
        path: 'liste',
        component:LicenceKeyComponent,
        canActivate: [AuthGuard],
        data: { permissions: ['adminAccess', 'adminEditUser']},
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LicenceKeysRoutingModule { }

export const routedComponents = [
  LicenceKeysComponent,
  LicenceKeyComponent
];
